import { LoadingSpinner } from '@web_opxp/components';
import { useTranslation } from '@web_opxp/features';
import { useSelector } from 'react-redux';
import ENV from '../../base/env';
import { getOrders } from '../selectors';
import styles from './OrdersList.module.scss';
import OrdersListItem from './OrdersListItem';

export default function OrdersList() {
  const orders = useSelector(getOrders);
  const { t } = useTranslation();
  if (!orders) {
    // if undefined - loading process
    return <LoadingSpinner assetsUrl={ENV.AssetsBaseUrl} />;
  }
  const renderOrders = () => {
    if (orders.length === 0) {
      // if empty - no orders available
      return (
        <tr>
          <td colSpan={4}>{t('manage:Orders.Notifications.noData')}</td>
        </tr>
      );
    }
    return orders.map((order) => <OrdersListItem key={order.referenceId} order={order} />);
  };
  return (
    <div>
      <table className={styles.ordersTable}>
        <thead>
          <tr className={styles.ordersListItem}>
            <th>{t('manage:Orders.number')}</th>
            <th>{t('manage:Orders.date')}</th>
            <th>{t('manage:Orders.total')}</th>
            <th>{t('common.common:Download')}</th>
          </tr>
        </thead>
        <tbody>{renderOrders()}</tbody>
      </table>
    </div>
  );
}
